import http from "./httpService";

export function getEntities(apiEndpoint) {
  return http.get(`/api/${apiEndpoint}`);
}

export function getMaxPriority(apiEndpoint, entityId = "") {
  if (entityId) {
    return http.get(`/api/${apiEndpoint}/priority/${entityId}`);
  } else {
    return http.get(`/api/${apiEndpoint}/priority`);
  }
}

export function getEntity(apiEndpoint, entityId) {
  return http.get(`/api/${apiEndpoint}/${entityId}`);
}

export function saveEntity(apiEndpoint, entityObj) {
  if (entityObj._id) {
    const body = { ...entityObj };
    delete body._id;
    return http.put(`/api/${apiEndpoint}/${entityObj._id}`, body);
  }

  return http.post(`/api/${apiEndpoint}`, entityObj);
}

export function deleteEntity(apiEndpoint, entityId) {
  return http.delete(`/api/${apiEndpoint}/${entityId}`);
}
